<template>

    <div class="mt-2" id="subnav">

        <nav class="flex justify-between">

            <ul class="flex flex-row justify-start">

                <inertia-link
                    :href="route('quick_start','helpdesk')"
                    class="rounded-tl-md px-6 py-3 font-bold"
                    :class="{'bg-white text-blue-500 hover:text-blue-700':$page.props.tab == 'helpdesk',
                    'bg-gray-400 bg-opacity-60 text-white hover:bg-opacity-90':$page.props.tab != 'helpdesk'}"
                    :style="$page.props.tab != 'helpdesk' ? 'box-shadow:inset 0px -11px 8px -10px rgba(0,0,0,0.1);' : ''">
                    Helpdesk
                </inertia-link>

                <inertia-link
                    :href="route('quick_start','standalone')"
                    class="px-6 py-3 border-l-2 border-r-2 border-gray-100 font-bold"
                    :class="{'bg-white text-blue-500 hover:text-blue-700':$page.props.tab == 'standalone',
                        'bg-gray-400 bg-opacity-60 text-white hover:bg-opacity-90':$page.props.tab != 'standalone'}"
                        :style="$page.props.tab != 'standalone' ? 'box-shadow:inset 0px -11px 8px -10px rgba(0,0,0,0.1);' : ''">
                    Standalone
                </inertia-link>

                <inertia-link
                    :href="route('quick_start','inapp')"
                    class="rounded-tr-md px-6 py-3 font-bold"
                    :class="{'bg-white text-blue-500 hover:text-blue-700':$page.props.tab == 'inapp',
                    'bg-gray-400 bg-opacity-60 text-white hover:bg-opacity-90':$page.props.tab != 'inapp'}"
                    :style="$page.props.tab != 'inapp' ? 'box-shadow:inset 0px -11px 8px -10px rgba(0,0,0,0.1);' : ''">
                    In-App
                </inertia-link>

                <div class="flex ml-4 self-center text-gray-400">
                    <vue-feather type="arrow-left" class="h-4 w-4 self-center mr-2"></vue-feather> Various ways to use {{ $page.props.app_name }}
                </div>
            </ul>

        </nav>

    </div>


</template>

<script>

    export default {
        components: {


        },
        data() {
            return {

            }
        },
        created() {

        },
        beforeUnmount() {

        },
        mounted() {

        },
        methods: {

        }
    }
</script>
